<template>
    <template v-if="props.image">
        <NuxtImg class="absolute right-0 top-0 h-[430px] w-full object-cover opacity-80 md:-top-[130px] md:h-[430px]" :src="props.src" :alt="alt" />
    </template>

    <UContainer class="relative">
        <UBreadcrumb class="pt-6" divider="/" :links="breadcrumbs" :ui="{ active: `text-${props.color}-600 dark:text-${props.color}-400` }" />

        <UPageHeader
            :title="props.title"
            :description="props.description"
            :icon="props.icon"
            :ui="{
                wrapper: 'relative py-8',
                headline: `mb-3 text-sm/6 font-semibold text-${props.color}-600 flex items-center gap-1.5`,
                title: `text-3xl sm:text-4xl font-bold text-${props.color}-600 dark:text-white tracking-tight`,
                description: 'mt-4 text-lg text-gray-600 dark:text-gray-400',
                icon: {
                    wrapper: 'flex',
                    base: `w-10 h-10 flex-shrink-0 text-${props.iconColor}-600`
                }
            }" />
    </UContainer>
</template>

<script setup>
    const config = useRuntimeConfig()

    const props = defineProps({
        breadcrumbs: {
            type: Array,
            default: () => [],
            required: true
        },
        title: {
            type: String,
            default: '',
            required: true
        },
        description: {
            type: String,
            default: '',
            required: false
        },
        icon: {
            type: String,
            default: '',
            required: false
        },
        iconColor: {
            type: String,
            default: 'green',
            required: false
        },
        color: {
            type: String,
            default: 'green',
            required: false
        },
        image: {
            type: Boolean,
            default: false,
            required: false
        },
        src: {
            type: String,
            default: '',
            required: false
        }
    })

    const alt = computed(() => {
        return `${config.public.company.name}`
    })
</script>
